import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SectionHead from "@/components/SectionHead";
import { Reveal } from "@/components/Reveal";

const IMG = "https://images.unsplash.com/photo-1770992161088-7ad66282c9af?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBnbGFzcyUyMG9mZmljZSUyMGFyY2hpdGVjdHVyZSUyMGludGVyaW9yJTIwdGVjaHxlbnwwfHx8fDE3ODk3NTU0NDB8MA&ixlib=rb-4.1.0&q=85";

export default function AboutSection() {
  return (
    <section data-testid="about-section" className="relative py-24">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-6 lg:grid-cols-2">
        <div>
          <SectionHead overline="About Talentify" title="Talent That Moves Businesses Forward." testid="about-heading" />
          <Reveal delay={0.1}>
            <div className="space-y-5 text-base leading-relaxed text-slate-400">
              <p>
                Talentify is a recruitment and talent acquisition company providing recruitment support to organisations across PAN India. Founded by a recruitment professional with 9 years of industry experience, Talentify brings deep expertise across IT and Non-IT hiring.
              </p>
              <p>
                Our experience includes supporting recruitment requirements for MNCs and Fortune 500 organisations, giving us an understanding of the speed, quality, confidentiality and stakeholder management expected in modern recruitment.
              </p>
              <p className="text-slate-300">
                We work as an extension of our clients' hiring teams, combining market understanding, targeted sourcing, candidate assessment and structured recruitment processes to deliver the right talent.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <Link
              to="/about"
              data-testid="about-learn-more-link"
              className="group mt-8 inline-flex items-center gap-2 text-sm font-semibold text-sky-400 transition-colors duration-300 hover:text-sky-300"
            >
              More about Talentify
              <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Reveal>
        </div>
        <Reveal delay={0.15} className="relative">
          <div className="relative overflow-hidden rounded-3xl border border-white/[0.08]">
            <div className="pointer-events-none absolute inset-0 z-10 bg-gradient-to-t from-[#030712]/80 via-transparent to-transparent" />
            <img
              src={IMG}
              alt="Recruitment consultants collaborating with business leaders in a modern boardroom"
              className="aspect-[4/3] w-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="glass-card absolute -bottom-6 -left-4 z-20 rounded-2xl px-6 py-4 shadow-2xl sm:-left-8">
            <p className="font-display text-2xl font-bold text-white">9+</p>
            <p className="text-xs text-slate-400">Years of Recruitment Expertise</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
